import Core, { Scaffold } from "@passportinc/hydra-core";
import DynamicString from "@passportinc/hydra-core/components/DynamicString";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import _ from "lodash";
import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

/**
 * Import custom validators
 */
import "./utils/validators";
import CartIcon from "./components/Cart/CartIcon";
import ToastProvider from "./components/ToastProvider";
import Root from "./Root";
import configureStore from "./redux/store";
import { maybeRedirect, tryJsonParse } from "./utils";

const { store, persistor } = configureStore();
export const queryClient = new QueryClient();

const App = () => (
	<Core
		currentAppPath="/permits"
		render={(renderProps) => {
			maybeRedirect({
				subdomain: renderProps.subdomain,
				permitsSubdomain: renderProps.permits_subdomain,
				currentSubdomain: renderProps.hydra_operator_name,
			});

			const showPhone = !tryJsonParse(_.get(renderProps, "settings.hydra_permits_footer_hide_contact_phone", false));
			const showEmail = !tryJsonParse(_.get(renderProps, "settings.hydra_permits_footer_hide_contact_email", false));

			const contact = {
				phone: DynamicString.resolve("hydra_permits_footer_contact_phone", _.get(renderProps, "contact.phone")),
				extension: DynamicString.resolve(
					"hydra_permits_footer_contact_extension",
					_.get(renderProps, "contact.extension"),
				),
				email: DynamicString.resolve("hydra_permits_footer_contact_email", _.get(renderProps, "contact.email")),
				name: DynamicString.resolve("hydra_permits_footer_contact_company", _.get(renderProps, "contact.name")),
				street: DynamicString.resolve(
					"hydra_permits_footer_contact_address_street",
					_.get(renderProps, "contact.street"),
				),
				cityStateZip: DynamicString.resolve(
					"hydra_permits_footer_contact_address_city_state_zip",
					_.get(renderProps, "contact.cityStateZip"),
				),
			};

			return (
				<Provider store={store}>
					<PersistGate persistor={persistor}>
						<QueryClientProvider client={queryClient}>
							<ToastProvider>
								<Scaffold
									currentAppPath={renderProps.currentAppPath}
									header={{
										menuButtons: [
											{
												key: "cart",
												component: <CartIcon />,
											},
										],
										title: "Permits Dashboard",
									}}
									footer={{
										faqPath: "/permits/faq",
										showPhone,
										showEmail,
										contact,
									}}
								>
									<Root {...renderProps} />
								</Scaffold>
							</ToastProvider>
						</QueryClientProvider>
					</PersistGate>
				</Provider>
			);
		}}
	/>
);

export default App;
